<template>
  <div class="checkout__footer fixed z-50 bottom-0 left-0 m-0 bg-white w-full flex flex-row flex-start shadow-sm py-3 px-6 lg:px-0">
    <div class="checkout__footer__wrapper flex flex-col lg:flex-row items-start lg:items-center">
      
      <button
        v-if="step === 1"
        class="btn btn-green group"
        @click="$emit('next')"
      >
        <span
          v-if="!stepOneReady"
          class="flex flex-row items-center"
        >
          <img class="group-hover:invert" src="/wp-content/themes/teachdigital/dist/img/ic_checkout_locked.svg" alt="Stap 1 is nog niet afgerond, selecteer een aanbieder" />
          <span class="ml-2">Door naar gegevens</span>  
        </span>
        <span
          v-if="stepOneReady"
          class="flex flex-row items-center"
        >
          <span class="mr-2">Door naar gegevens</span>  
          <img class="group-hover:invert" src="/wp-content/themes/teachdigital/dist/img/ic_checkout_proceedarrow.svg" alt="Stap 1 is afgerond, klik om door te gaan" />
        </span> 
      </button>

      <button
        v-if="step === 2"
        class="btn btn-green group"
        @click="$emit('finish')"
      >
        <span
          v-if="!stepTwoReady && pageType === 'inschrijven'"
          class="flex flex-row items-center"
        >
          <img class="group-hover:invert" src="/wp-content/themes/teachdigital/dist/img/ic_checkout_locked.svg" alt="Stap 2 is nog niet afgerond, vul alle gegevens in" />
          <span class="ml-2">
            {{ !isSending ? 'Inschrijven' : 'Laden...' }}
          </span>  
        </span>
        <span
          v-if="stepTwoReady && pageType === 'inschrijven'"
          class="flex flex-row items-center"
        >
          <span>
            {{ !isSending ? 'Inschrijven' : 'Laden...' }}  
          </span>  
        </span> 

        <span
          v-if="!stepTwoReady && pageType === 'offerte-aanvragen'"
          class="flex flex-row items-center"
        >
          <img class="group-hover:invert" src="/wp-content/themes/teachdigital/dist/img/ic_checkout_locked.svg" alt="Stap 2 is nog niet afgerond, vul alle gegevens in" />
          <span class="ml-2">
          
            {{ !isSending ? 'Aanvragen' : 'Laden...' }}

          </span>  
        </span>
        <span
          v-if="stepTwoReady && pageType === 'offerte-aanvragen'"
          class="flex flex-row items-center"
        >
          <span>
            {{ !isSending ? 'Aanvragen' : 'Laden...' }}  
          </span>  
        </span> 

      </button>

      <transition name="fade" mode="out-in">
        <div v-show="proceedError" class="flex flex-row items-start bg-red-100 rounded-lg py-5 px-6 mb-4 text-base text-red-700 mb-3 mb-0 mt-2 lg:mt-0 ml-0 lg:ml-4" style="height: auto !important;" role="alert">
          {{ proceedErrorMsg }}
          <button type="button" class="btn btn-white" @click="proceedError = false">Begrepen</button>
        </div>
      </transition>

      <transition name="fade" mode="out-in">
        <div v-show="hasError" class="flex flex-row items-start bg-red-100 rounded-lg py-5 px-6 mb-4 text-base text-red-700 mb-3 mb-0 ml-0 mt-2 lg:mt-0 lg:ml-4" style="height: auto !important;" role="alert">
          {{ errorMessage }}
          <button type="button" class="btn btn-white" @click="hasError = false">Begrepen</button>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    step: {
      type: Number,
      required: true,
      default: 1,
    },
    stepOneReady: {
      type: Boolean,
      required: true,
      default: false,
    },
    stepTwoReady: {
      type: Boolean,
      required: true,
      default: false,
    },
    pageType: {
      type: String,
      required: true,
      default: '',
    },
    hasError: {
      type: Boolean,
      required: true,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    isSending: {
      type: Boolean,
      required: true,
      default: false,
    },
    proceedError: {
      type: Boolean,
      required: false,
      default: false,
    },
    proceedErrorMsg: {
      type: String,
      required: false,
    },
  },
}
</script>